import { asyncType } from "redux/types/asyncTypes";

export const FETCH_AFF_COMMISSIONS = asyncType(" FETCH_AFF_COMMISSIONS");
export const FETCH_AFF_REC_COMMISSIONS = asyncType("FETCH_AFF_REC_COMMISSIONS");
